// Free-standing city billboards — our own flat panels (not model meshes) that
// carry dynamic HypeTunes content (featured-track art now; HypeClip video
// later). Positions are tuned live with ?bb=edit and persist to localStorage
// (key `bb:<id>`), then get pasted back here to bake — same contract as the
// studio video card (src/components/VideoPanel.jsx).
//
// pos = [x, y, z] in the model city's world space; rotY = yaw; height in metres
// (width follows the artwork's aspect). Defaults are rough — place them in
// ?bb=edit and paste the logged lines over these.
// type: 'image' (featured-track poster) | 'video' (music-video clip, 16:9).
// A video billboard autoplays muted; click it to hear it.
// dj: true — this (large) board hosts the radio DJ video-host cameo: while the
// DJ is live it shows the Anam stream instead of its content, then reverts
// (see DjBillboardHost / CityBillboards). Reserve it for the big boards.
// nowPlaying: true — this board mirrors the district station's CURRENT song:
// its cover art (square for most songs), and the animated artwork video if the
// track has one. bb1 is the center screen you spawn facing.
export const CITY_BILLBOARDS = [
  { id: 'bb1', pos: [0, 9, -12], rotY: 0, height: 7, nowPlaying: true, dj: true },
  { id: 'bb2', pos: [22, 9, 6], rotY: -1.1, height: 9, type: 'image', dj: true },
  { id: 'bb3', pos: [-22, 9, 6], rotY: 1.1, height: 9, type: 'image', dj: true },
];
